/**
 * @flow
 * @relayHash bdc66daa956fb167163f86f8aa61f0cd
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreatePlaylistInput = {
  clientMutationId?: ?string,
  title: string,
  description?: ?string,
};
export type MyPlaylists_createPlaylistMutationVariables = {|
  input: CreatePlaylistInput
|};
export type MyPlaylists_createPlaylistMutationResponse = {|
  +createPlaylist: ?{|
    +new_playlist_edge: ?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +description: ?string,
        +can_edit: ?boolean,
        +playlist_songs: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string
            |}
          |}>
        |},
      |}
    |}
  |}
|};
export type MyPlaylists_createPlaylistMutation = {|
  variables: MyPlaylists_createPlaylistMutationVariables,
  response: MyPlaylists_createPlaylistMutationResponse,
|};
*/


/*
mutation MyPlaylists_createPlaylistMutation(
  $input: CreatePlaylistInput!
) {
  createPlaylist(input: $input) {
    new_playlist_edge {
      node {
        id
        title
        description
        can_edit
        playlist_songs(first: 99999) {
          edges {
            node {
              id
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreatePlaylistInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreatePlaylistInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "can_edit",
  "args": null,
  "storageKey": null
},
v6 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "PlaylistSongEdge",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "PlaylistSong",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "cursor",
        "args": null,
        "storageKey": null
      }
    ]
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "endCursor",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "hasNextPage",
        "args": null,
        "storageKey": null
      }
    ]
  }
],
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "MyPlaylists_createPlaylistMutation",
  "id": null,
  "text": "mutation MyPlaylists_createPlaylistMutation(\n  $input: CreatePlaylistInput!\n) {\n  createPlaylist(input: $input) {\n    new_playlist_edge {\n      node {\n        id\n        title\n        description\n        can_edit\n        playlist_songs(first: 99999) {\n          edges {\n            node {\n              id\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n      }\n    }\n  }\n}\n",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "createPlaylist",
          "new_playlist_edge",
          "node",
          "playlist_songs"
        ]
      }
    ]
  },
  "fragment": {
    "kind": "Fragment",
    "name": "MyPlaylists_createPlaylistMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createPlaylist",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePlaylistPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "new_playlist_edge",
            "storageKey": null,
            "args": null,
            "concreteType": "PlaylistEdge",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Playlist",
                "plural": false,
                "selections": [
                  v2,
                  v3,
                  v4,
                  v5,
                  {
                    "kind": "LinkedField",
                    "alias": "playlist_songs",
                    "name": "__UserPlaylistContainer_playlist_songs_connection",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PlaylistSongConnection",
                    "plural": false,
                    "selections": v6
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "MyPlaylists_createPlaylistMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createPlaylist",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePlaylistPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "new_playlist_edge",
            "storageKey": null,
            "args": null,
            "concreteType": "PlaylistEdge",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Playlist",
                "plural": false,
                "selections": [
                  v2,
                  v3,
                  v4,
                  v5,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "playlist_songs",
                    "storageKey": "playlist_songs(first:99999)",
                    "args": v7,
                    "concreteType": "PlaylistSongConnection",
                    "plural": false,
                    "selections": v6
                  },
                  {
                    "kind": "LinkedHandle",
                    "alias": null,
                    "name": "playlist_songs",
                    "args": v7,
                    "handle": "connection",
                    "key": "UserPlaylistContainer_playlist_songs",
                    "filters": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4373263a578db7bd946d2820b3f32d5b';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Playlist/Recommendation/__generated__/MyPlaylists_createPlaylistMutation.graphql.js